import React, { createContext, useContext, useState } from 'react';
import '../styles/loading.css';

const LoadingContext = createContext();

export function useLoading() {
  return useContext(LoadingContext);
}

export function LoadingProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const startLoading = () => setIsLoading(true);
  const stopLoading = () => setIsLoading(false);
  const setErrorMessage = (message) => setError(message);
  const clearError = () => setError(null);

  const value = {
    isLoading,
    error,
    startLoading,
    stopLoading,
    setErrorMessage,
    clearError
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
      {error && (
        <div className="error-toast">
          <p>{error}</p>
          <button onClick={clearError}>&times;</button>
        </div>
      )}
    </LoadingContext.Provider>
  );
}
